import React from 'react';
import classes from './Tile.css';

const Tile = (props) => (
    <div className={classes[props.type]} onClick={() => props.clicked(props.ele)}>
            {props.ele}
    </div>
);

export default Tile;


// WEBPACK FOOTER //
// ./src/components/Contents/Lists/Tile/Tile.js